/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_StreetInputs */

const en_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

const es_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Callejera`)
};

const fr_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rue`)
};

const de_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street`)
};

const ja_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストリート`)
};

const zh_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`街头摄影`)
};

const ar_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير شوارع`)
};

const id_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalanan`)
};

const it_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Street Photography`)
};

const ru_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уличная`)
};

const pt_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografia de Rua`)
};

const ko_val_street = /** @type {(inputs: Val_StreetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스트리트`)
};

/**
* | output |
* | --- |
* | "Street" |
*
* @param {Val_StreetInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_street = /** @type {((inputs?: Val_StreetInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_StreetInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_street(inputs)
	if (locale === "es") return es_val_street(inputs)
	if (locale === "fr") return fr_val_street(inputs)
	if (locale === "de") return de_val_street(inputs)
	if (locale === "ja") return ja_val_street(inputs)
	if (locale === "zh") return zh_val_street(inputs)
	if (locale === "ar") return ar_val_street(inputs)
	if (locale === "id") return id_val_street(inputs)
	if (locale === "it") return it_val_street(inputs)
	if (locale === "ru") return ru_val_street(inputs)
	if (locale === "pt") return pt_val_street(inputs)
	return ko_val_street(inputs)
});